

const columnList: Array<any> = [
    {
        prop: "user_name",
        label: "消费id",
        width: 80,
    },
    {
        prop: "parent_name",
        label: "返现id",
        width: 80,
    },
    {
        prop: "balance_currency",
        label: "返现金额",
        width: 100,
    },
    {
        prop: "pay_text",
        label: "返现类型",
        width: 80,
    },
    {
        prop: "cash_type_name",
        label: "返现级别",
        width: 80,
    },
    {
        prop: "create_time_text",
        label: "返现时间",
        width: 80,
    }
];

import { defineComponent, inject, ref, onMounted, reactive } from "vue";
import { getOrderTable } from "@/api/http";
import { validateInput } from "@/assets/js/formRules";
import { Request } from "@/api/request";

export default defineComponent({
    name: "cashBackStatistics",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["返现统计"]);
        const headClass = inject("headClass");
        let loading = ref(false),
            userinfo = ref(false),
            tableData = ref([] as Array<any>),
            currentPage = ref(1),
            pageSize = ref(10),
            total = ref(1),
            total_price = ref(0);
        
        
        let getTableData = () => {
                loading.value = true;
                Request.axiosInstance({
                    url: 'adminapi/Order/userCashBackList',
                    data: {page:currentPage.value,pagesize:pageSize.value}
                }).then((res: any) => {
                    tableData.value = res.content.list;
                    total.value = res.content.total;
                    loading.value = false;
                    total_price.value = res.content.total_price;
                })
            },
            getSummaries = (param: any): Array<string> => {
                const {columns, data} = param;
                const sums: any = [];
                const propArr = [
                    "balance_currency"
                ];
                columns.forEach((column: any, index: number) => {
                    if (index === 0) {
                        sums[index] = "合计";
                        return;
                    }
                    const values = data.map((item: any) =>
                        Number(item[column.property])
                    );
                    if (
                        propArr.findIndex((item: any) => {
                            return item == column.property;
                        }) > -1
                    ) {
                        // 增加合计项
                        if (column.property == "balance_currency") {
                            sums[index] = total_price.value;
                        }
                    } else {
                        sums[index] = "";
                    }
                });
                return sums;
            },
            handleSizeChange = (value: number): void => {
                pageSize.value = value;
                getTableData();
            },
            handleCurrentChange = (pageSize: number): void => {
                currentPage.value = pageSize;
                getTableData();
            };
        onMounted(async() => {
            getTableData();
        });
        
        return {
            loading,
            tableData,
            headClass,
            getTableData,
            currentPage,
            pageSize,
            columnList,
            total,
            handleSizeChange,
            handleCurrentChange,
            getSummaries
        };
    },
});
